import { render, staticRenderFns } from "./UpdateMasterYesNo.vue?vue&type=template&id=5ccf0802&scoped=true&"
import script from "./UpdateMasterYesNo.vue?vue&type=script&lang=js&"
export * from "./UpdateMasterYesNo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMasterYesNo.vue?vue&type=style&index=0&id=5ccf0802&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf0802",
  null
  
)

export default component.exports